module.exports = __webpack_public_path__ + "img/scene5.403c0b1e.webp";